import { Component, OnInit, ViewEncapsulation, Inject, Input, ViewChild } from '@angular/core';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import {
  environment
} from 'src/environments/environment';
import { GlobalService } from '../service/global.service';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';

import { WorklistSaleLeadApprovalFormComponent } from '../worklist-sale-lead-approval-form/worklist-sale-lead-approval-form.component';
import { WorklistSaleCloseDealFormComponent } from '../worklist-sale-close-deal-form/worklist-sale-close-deal-form.component';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-worklist-sale',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './worklist-sale.component.html',
  styleUrls: ['./worklist-sale.component.css']
})
export class WorklistSaleComponent implements OnInit {
  //Import child component for call function
  @ViewChild(WorklistSaleLeadApprovalFormComponent) childLeadApprovalForm: WorklistSaleLeadApprovalFormComponent;

  //Import child component for call function
  @ViewChild(WorklistSaleCloseDealFormComponent) childClosedealApprovalForm: WorklistSaleCloseDealFormComponent;

  //Zone param to child Lead Approval Form component
  LeadApprovalForm: FormGroup

  // variable modal
  titlemodal: string
  detailmodal: string


  //Zone param to child Lead Close Deal Form component
  CloseDealForm: FormGroup


  // Zone Rest API variable
  baseurl: string;
  // Zone pagination variable
  public indexNo: number = 0
  public currentPageNumber: number
  public ProjectSaleTotal: number
  public totalPages: number
  public environment: number
  // ProjectSale List on current user hand
  WorklistProjectSaleList: ProjectSaleInfo[]
  // Zone Search variable
  txtSearchProjectLeadCode: string
  txtSearchProjectLeadName: number
  txtSearchCompany: string
  //flag view detail
  viewdetail: boolean = false

  constructor(private httpClient: HttpClient, private GlobalService: GlobalService, private formBuilder: FormBuilder, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }
  ngOnInit(): void {
    this.currentPageNumber = 1;
    // set PageSize
    this.environment = environment.PageSize;
    //call function load ProjectSale list on hand current 
    this.OnLoadProjectSaleWorklistList();
    // call function load count all ProjectSale list on hand current 
    this.OnLoadCountProjectSaleWorklistList();


    this.LeadApprovalForm = this.formBuilder.group({
      txtContactDate: [null, Validators.required],
      txtContactPerson: [null, Validators.required],
      txtEmail: [null],
      txtTel: [null, Validators.required],
      ddlCustomerType: [null, Validators.required],
      ddlStatus: [null, Validators.required],
      ddlCompanyName: [null, Validators.required],
      txtProjectLeadCode: [null],
      txtProjectLeadName: [null, Validators.required],
      ddlType: [null, Validators.required],
      ddlCategory: [null, Validators.required],
      txtTool: [null],
      ddlPhase: [null, Validators.required],
      txtBudget: [null],
      ddlExpectedClosePeriodMonth: [null],
      ddlExpectedClosePeriodYear: [null],
      arraySupportTeam: this.formBuilder.array([this.createItemSupportTeamName()]),
      txtRemark: [null],
      chkAction: [null],
      txtComment: [null],
      hideProjectSaleRequestTypeCode: [null],
      hideProjectSaleStatusWorkflowCodeCurrent: [null],
      hideProjectGroupMapping: [null],
     },
      {
        // Used custom form validator 
        validator: []
      }

    );


    this.CloseDealForm = this.formBuilder.group({
      ProjectSaleCode: [null],
      ProjectSaleName: [null],
      ProjectSaleCompany: [null],
      ProjectSaleEstimatePrice: [null, Validators.required],
      ProjectSaleActualPrice: [null, Validators.required],
      ProjectSaleEstimateTime: [null, Validators.required],
      PorjectSaleCommission: [null, Validators.required],
      Commissiontotal: [null],
      ProjectStartDealDate: [null],
      ProjectEndDealDate: [null],
      ProjectHeadSale: [null],
      ProjectLeadOwner: [null],
      Comment: [null],
    },
      {
        // Used custom form validator 
        validator: []
      }

    );

  }


  // ------------------------------------------------------ Function WOrklist Zone ------------------------------------------------------

  // Call Rest api for load ProjectSale list on hand current user 
  async LoadProjectSaleWorklistList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;
      var objectjson = {};

      objectjson['ProjectSaleCode'] = this.txtSearchProjectLeadCode;
      objectjson['ProjectSaleName'] = this.txtSearchProjectLeadName;
      objectjson['ProjectSaleCompanyId'] = this.txtSearchCompany;

      objectjson['EmpcodecurrentOnWorklistSale'] = this.GlobalService.checkUndefinedString(localStorage.getItem("EmpCode")); // get lead on hand current user only


      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSaleWorklist",
          strjson, httpOptions)
        .toPromise()
    }
  }

  // Call Rest api for load count all ProjectSale list on hand current user 
  async LoadCountProjectSaleWorklistList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};


      objectjson['ProjectSaleCode'] = this.txtSearchProjectLeadCode;
      objectjson['ProjectSaleName'] = this.txtSearchProjectLeadName;
      objectjson['ProjectSaleCompanyId'] = this.txtSearchCompany;

      objectjson['EmpcodecurrentOnWorklistSale'] = this.GlobalService.checkUndefinedString(localStorage.getItem("EmpCode")); // get lead on hand current user only




      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<number>(this.baseurl + "ProjectSale/GetAllCountProjectSaleWorklist",
          strjson, httpOptions)
        .toPromise()
    }
  }

  OnLoadProjectSaleWorklistList(traget = null) {

    // check call function from change page or onloadfrist
    if (traget != null) {
      this.LoadProjectSaleUpdatePagination(traget);
    }

    //call function load ProjectSale list on hand current user
    this.LoadProjectSaleWorklistList().then(data => {
      this.WorklistProjectSaleList = data;
    })
  }


  OnLoadCountProjectSaleWorklistList() {

    //call function load count all ProjectSale list on hand current user
    this.LoadCountProjectSaleWorklistList().then(data => {
      this.ProjectSaleTotal = data;
      if(this.ProjectSaleTotal == 0) this.currentPageNumber = 0;
      this.totalPages = Math.ceil(this.ProjectSaleTotal / environment.PageSize);

    })
  }


  //Function Onclick Search
  OnClickSearchProjectSaleWorklist() {
    this.currentPageNumber = 1; // reset page number
    //call function load ProjectSale list on hand current user
    this.OnLoadProjectSaleWorklistList();
    //call function load count all ProjectSale list on hand current user
    this.LoadCountProjectSaleWorklistList().then(data => {
      this.ProjectSaleTotal = data;
      this.currentPageNumber = this.ProjectSaleTotal == 0 ? 0 : 1;
      this.totalPages = Math.ceil(this.ProjectSaleTotal / environment.PageSize);
    })
  }

  // Function Onclick Cancel
  CancelSearchSection() {
    this.ClearSearch();
    this.OnClickSearchProjectSaleWorklist();
  }

  // function clear search control
  ClearSearch() {
    this.txtSearchProjectLeadCode = null
    this.txtSearchProjectLeadName = null
    this.txtSearchCompany = null
  }

  // Function Update variable abount pagination
  LoadProjectSaleUpdatePagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;

  }

  callbackLoadWorklist() {
    //call function load ProjectSale list on hand current user
    this.OnLoadProjectSaleWorklistList();
    // call function load count all ProjectSale list on hand current user
    this.OnLoadCountProjectSaleWorklistList();
  }

  // ----------------------------------------------------End Function WOrklist Zone ------------------------------------------------------


    // ---------------------------------------------------- Function Lead Approval Form ------------------------------------------------------
  // View detail for update lead approval form
  Click_onViewforUpdateLeadApprove(id) {
    this.childLeadApprovalForm.Click_onViewforUpdateLeadApprove(id);
  }


  createItemSupportTeamName() {
    return this.formBuilder.group({
      SupporTeamName: [''],
    },
      {
        // Used custom form validator 
        validator: []
      }
    );  }

  callbackloadworklist() {
    //call function load ProjectSale list on hand current 
    this.OnLoadProjectSaleWorklistList();
    // call function load count all ProjectSale list on hand current 
    this.OnLoadCountProjectSaleWorklistList();
  }

  UpdateValueModal(traget) {
    this.titlemodal = traget.titlemodal;
    this.detailmodal = traget.detailmodal;
  }

    // ---------------------------------------------------- End Function Lead Approval Form ------------------------------------------------------




  // ---------------------------------------------------- Function Close deal Approval Form ------------------------------------------------------
  // View detail for update close deal approval form
  Click_onViewforUpdateClosedealApprove(id) {
    this.childClosedealApprovalForm.Click_onViewforUpdateClosedealApprove(id);
  }

   // ---------------------------------------------------- End Function Close deal Approval Form ------------------------------------------------------


}
